import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'lineBreak',
})
export class LineBreakPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);
  transform(value: string | null | undefined): SafeHtml {
    if (!value) return '';
    const formattedText = value
      .split(/\r?\n/)
      .map((line) => `<p >${line || '&nbsp;'}</p>`)
      .join('');
    return this.sanitizer.bypassSecurityTrustHtml(formattedText);
  }
}
